export default class Header {
  constructor(element) {
    this.element = element;
    this.scrollLimit = 0.05;
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;

    // Éléments principaux
    this.servicesMenu = this.element.querySelector('#services');
    this.humainMenu = this.element.querySelector('#humains');
    this.servicesItem = this.element.querySelector('.services-js');
    this.humainsItem = this.element.querySelector('.humains-js');
    this.serviceToggler = this.servicesItem ? this.servicesItem.querySelector(':scope > a') : null;
    this.humainToggler = this.humainsItem ? this.humainsItem.querySelector(':scope > a') : null;

    this.mq = window.matchMedia('(min-width: 1024px)');

    // Initialisation
    this.init();
    this.initNavMobile();
    this.initSubmenusDesktop();
    this.initInlineMobileSubmenus();
    this.initResizeWatcher();
  }

  isDesktop() {
    return this.mq.matches;
  }

  /* -------------------- SCROLL ------------------- */
  init() {
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;
    this.setHeaderState();
    this.setDirectionState();

    // Fermer menu mobile au scroll
    if (!this.isDesktop() && this.html.classList.contains('nav-is-active')) {
      this.html.classList.remove('nav-is-active');
      this.element.querySelector('.js-toggle')?.classList.remove('is-active');
      this.servicesItem?.classList.remove('mobile-open');
      this.humainsItem?.classList.remove('mobile-open');
      this.closeAllMobileGroups();
    }
  }

  setHeaderState() {
    const scrollHeight = document.scrollingElement.scrollHeight;
    if (this.scrollPosition > scrollHeight * this.scrollLimit)
      this.html.classList.add('header-is-hidden');
    else this.html.classList.remove('header-is-hidden');

    if (this.scrollPosition > 0)
      this.html.classList.add('header-has-bg');
    else
      this.html.classList.remove('header-has-bg');
  }

  setDirectionState() {
    if (this.scrollPosition >= this.lastScrollPosition) {
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');
    } else {
      this.html.classList.remove('is-scrolling-down');
      this.html.classList.add('is-scrolling-up');
    }
  }

  /* -------------------- NAV MOBILE ------------------- */
  initNavMobile() {
    const toggle = this.element.querySelector('.js-toggle');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const willOpen = !this.html.classList.contains('nav-is-active');
        this.html.classList.toggle('nav-is-active');
        toggle.classList.toggle('is-active');
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (!willOpen) {
          this.servicesItem?.classList.remove('mobile-open');
          this.humainsItem?.classList.remove('mobile-open');
          this.closeAllMobileGroups();
        }
      });
    }

    const links = this.element.querySelectorAll('.header__nav a');
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const inServices = this.servicesItem && (link === this.serviceToggler || this.servicesItem.contains(link));
        const inHumains = this.humainsItem && (link === this.humainToggler || this.humainsItem.contains(link));
        if (!this.isDesktop() && (link === this.serviceToggler || link === this.humainToggler)) {
          e.preventDefault();
          const li = link.closest('.menu-item');
          const willOpen = !li.classList.contains('mobile-open');
          this.servicesItem?.classList.remove('mobile-open');
          this.humainsItem?.classList.remove('mobile-open');
          if (willOpen) li.classList.add('mobile-open');
          return;
        }
        if (!this.isDesktop() && (inServices || inHumains)) return;
        this.html.classList.remove('nav-is-active');
        this.element.querySelector('.js-toggle')?.classList.remove('is-active');
      });
    });
  }

  /* -------------------- MOBILE INLINE SUBMENUS ------------------- */
  initInlineMobileSubmenus() {
    if (this.isDesktop()) return;
    // Gestion des sous-menus inline
    const groups = this.element.querySelectorAll('.mobile-submenu__group');
    groups.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const list = btn.nextElementSibling;
        const parent = btn.closest('.mobile-submenu');
        parent.querySelectorAll('.mobile-submenu__group').forEach((b) => {
          if (b !== btn) b.classList.remove('is-open');
        });
        parent.querySelectorAll('.mobile-submenu__list').forEach((ul) => {
          if (ul !== list) ul.classList.remove('is-open');
        });
        btn.classList.toggle('is-open');
        list.classList.toggle('is-open');
      });
    });

    // Permettre d'ouvrir/fermer un sous-menu même si pas de .mobile-submenu__group
    const menuItems = this.element.querySelectorAll('.menu-item');
    menuItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (item.querySelector('.mobile-submenu__group')) return;
        
        this.closeAllMobileGroups();

        const list = item.querySelector('.mobile-submenu__list');
        if (list) list.classList.add('is-open');
      });
    });
  }

  closeAllMobileGroups() {
    this.element.querySelectorAll('.mobile-submenu__group').forEach((b) => b.classList.remove('is-open'));
    this.element.querySelectorAll('.mobile-submenu__list').forEach((ul) => ul.classList.remove('is-open'));
  }

  /* -------------------- SOUS-MENUS DESKTOP ------------------- */
  initSubmenusDesktop() {
        // Optimisation : gestion centralisée du hover et fermeture des sous-menus
        const menuItems = this.element.querySelectorAll('.menu-item');
        const submenus = [
          { item: this.servicesItem, menu: this.servicesMenu },
          { item: this.humainsItem, menu: this.humainMenu }
        ];

        menuItems.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            if (!this.isDesktop()) return;
            // Ferme tous les sous-menus et retire tous les hovers
            submenus.forEach(({ item: subItem, menu }) => {
              if (item !== subItem && menu) {
                menu.classList.remove('open-menu');
                subItem?.classList.remove('is-hovered');
              }
            });
          });
        });
    const closeAll = () => {
      this.servicesMenu?.classList.remove('open-menu');
      this.humainMenu?.classList.remove('open-menu');
    };

    // SERVICES
    if (this.servicesItem && this.servicesMenu) {
      this.servicesItem.addEventListener('mouseenter', () => {
        if (!this.isDesktop()) return;
        closeAll();
        this.servicesMenu.classList.add('open-menu');
        this.servicesItem.classList.add('is-hovered');
        this.humainsItem?.classList.remove('is-hovered');
      });
      this.servicesMenu.addEventListener('mouseleave', () => {
        if (!this.isDesktop()) return;
        this.servicesMenu.classList.remove('open-menu');
        this.servicesItem.classList.remove('is-hovered');
      });
      // Fermer le sous-menu services si on survole humainsItem
      this.humainsItem?.addEventListener('mouseenter', () => {
        if (!this.isDesktop()) return;
        this.servicesMenu.classList.remove('open-menu');
        this.servicesItem.classList.remove('is-hovered');
      });
    }

    // HUMAINS
    if (this.humainsItem && this.humainMenu) {
      this.humainsItem.addEventListener('mouseenter', () => {
        if (!this.isDesktop()) return;
        closeAll();
        this.humainMenu.classList.add('open-menu');
      });

      const wrapper = this.humainMenu.querySelector('.humain-bg-wrapper');
      if (wrapper) {
        const layers = wrapper.querySelectorAll('.humain-bg-layer');
        const cards = this.humainMenu.querySelectorAll('.humain-card');
        let current = 0;
        const defaultBg = '/assets/images/header/humain-0.webp';

        const swapBg = (newBg) => {
          const next = 1 - current;
          layers[next].style.backgroundImage = `url(${newBg})`;
          layers[next].classList.add('active');
          layers[current].classList.remove('active');
          current = next;
        };

        cards.forEach((card) => {
          card.addEventListener('mouseenter', () => {
            if (!this.isDesktop()) return;
            swapBg(card.dataset.bg || defaultBg);
          });
        });
        this.humainMenu.addEventListener('mouseleave', () => {
          this.humainMenu.classList.remove('open-menu');
          this.humainsItem.classList.remove('is-hovered');
        });
        // Fermer le sous-menu humains si on survole servicesItem
        this.servicesItem?.addEventListener('mouseenter', () => {
          if (!this.isDesktop()) return;
          this.humainMenu.classList.remove('open-menu');
          swapBg(defaultBg);
        });
      }
    }
  }


  /* -------------------- PRÉCHARGEMENT D'IMAGES ------------------- */
  preloadImages(urls = []) {
    urls.forEach((url) => {
      if (!url) return;
      const img = new Image();
      img.src = url;
    });
  }

  /* -------------------- RESIZE WATCHER ------------------- */
  initResizeWatcher() {
    this.mq.addEventListener('change', () => {
      this.html.classList.remove('nav-is-active');
      this.element.querySelector('.js-toggle')?.classList.remove('is-active');
      this.servicesItem?.classList.remove('mobile-open');
      this.humainsItem?.classList.remove('mobile-open');
      this.closeAllMobileGroups();
    });
  }
}